import { createAction } from '@reduxjs/toolkit';

export const helpersUpdateIsLoading = createAction('helpers/updateIsLoading');
export const helpersUpdateIsDashboard = createAction('helpers/updateIsDashboard');
export const helpersUpdateIsOpenProduct = createAction('helpers/updateIsOpenProduct');
export const helpersUpdateIsFirstLoadProduct = createAction('helpers/updateIsFirstLoadProduct');
export const helpersUpdateAllSectionList = createAction('helpers/updateAllSectionList');

export const helperUpdateFooter = createAction('helpers/updateFooter');
export const helpersUpdateSubscriptionModalOpen = createAction('helpers/updateSubscriptionModalOpen');
export const helpersUpdateSubscriptionModalShow = createAction('helpers/updateSubscriptionModalShow');

export const helpersUpdatePlanType = createAction('helpers/updatePlanType');
